import { useCallback, useSyncExternalStore } from "react";

/**
 * Subscribe to a CSS media query, e.g. useMediaQuery("(min-width: 640px)").
 * Returns `false` during SSR / when matchMedia is unavailable.
 */
export function useMediaQuery(query) {
  const subscribe = useCallback(
    (cb) => {
      if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {};
      const mq = window.matchMedia(query);
      if (typeof mq.addEventListener === "function") {
        mq.addEventListener("change", cb);
        return () => mq.removeEventListener("change", cb);
      }
      mq.addListener(cb); // older Safari
      return () => mq.removeListener(cb);
    },
    [query]
  );
  const getSnapshot = () =>
    typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false;
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** Tailwind `sm` breakpoint and up (two-column layouts switch on here). */
export const useIsSmUp = () => useMediaQuery("(min-width: 640px)");
